<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：プロパティの編集画面(STFMFM02C27UpdatePropert)  プロパティの編集                                                  _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div
    class="overlay"
    :class="[isConfirmShow ? showClass : hideClass]"
    id="popup-collectFileRegist"
    ref="content"
  >
    <div class="popup" style="width: 700px">
      <div class="popup-head">プロパティの編集</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <div>
          <div>
            <br>
          </div>
          プロパティを編集してください。
          <div>
            <br>
          </div>
        </div>
        <div>
          <div class="flex-row">
            <span class="row-label">名称</span>
            <span class="row-content">
              <input
                type="text"
                maxlength="255"
                class="frm-text"
                ref="fileName"
                tabindex="1"
                v-model.trim="fileName"
                v-bind:class="{ error: isErrorfileName }"
                style="width:100%;height:20px"
                />
            </span>
          </div>
          <div class="detail-error" v-show="fileNameErrorMsg != ''">
              {{ this.fileNameErrorMsg }}
          </div>
          <div>
            <br>
          </div>
          <!-- No4:スキャナ保存対応 書類ID start-->
          <div class="flex-row">
            <span  class="row-label">書類ID</span>
            <span class="row-content">
              {{this.paperID}}
            </span>           
          </div>
          <div>
            <br>
          </div>
          <!-- No4:スキャナ保存対応 書類ID end-->
          <div class="flex-row" v-if="denchouhou == '1'">
            <span class="row-label">書類種別<span style="font-size:6px">(任意)</span></span>
            <div class="row-content"> 
              <select 
                class="frm-select frm-size-110px"
                @change="handleChangeFileType" 
                v-model="this.paperType"
                tabindex="2"
                >
                <option v-for="item in this.paperTypeNameList" :key="item.code" :value="item.code">
                  {{ item.name }}
                </option>             
              </select>
              <span class="ml-10px">
                  <input
                    type="text"
                    maxlength="10"
                    class="frm-text w-180px"
                    v-model.trim="this.otherPaperTypeName"
                    :disabled="isDisabled"
                    v-bind:class="{ error: isErrorOtherPaperTypeName }"
                    tabindex="3"
                  />
              </span>
            </div>
          </div>
          <div class="detail-error" v-show="otherPaperTypeNameErrorMsg != ''">
            {{ this.otherPaperTypeNameErrorMsg }}
          </div>
          <div>
            <br>
          </div>
          <div class="flex-row">
            <span class="row-label">備考<span style="font-size:6px">(任意)</span></span>
            <div class="row-content">
            <textarea 
              maxlength="200"
              id="textAreaValue"
              class="frm-text text-input-area" 
              v-bind:class="{ error: isErrorRemarks }"
              wrap="hard"
              tabindex="4"
              v-model.trim="this.remarks"
            >
            </textarea>
            </div>
          </div>
          <div class="detail-error" v-show="remarksErrorMsg != ''">
              {{ this.remarksErrorMsg }}
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              tabindex="5"
              class="frm-btn strong large"
              @click="okBtnCliked"
              ref="refYesBtn"
            >
            確定
            </button>
            <button
              tabindex="6"
              class="frm-btn large"
              ref="disagreeButton"
              @click="canCelBtnClicked"
              @blur="onblur"
            >
            キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapMutations } from "vuex";
import ErrorMessage from "@/components/ErrorMessage.vue";
import validation from "@/util/validation";
import Common from "@/util/common.js";
import {PAPERTYPE_LIST,} from "@/util/data.js";
import { API_STFMFM02C27_UpdatePropert} from "@/api/Modules/FM02/STFMFM02C27.js";
export default {
  name: "STFMFM02C27UpdatePropert",
  components: {
    ErrorMessage,
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      inputedTextValue: "",
      fileName:"",
      paperType: "",
      otherPaperTypeName:"",
      remarks:"",
      isUpadateCauseErr: false,
      errorMsg: "",
      inputedFileType: "",
      denchouhou:0,
      paperTypeNameList: PAPERTYPE_LIST, //書類種類リスト
      // ファイル名必須入力      
      fileNameErrorMsg:"",
      isErrorfileName: false,          
      otherPaperTypeNameErrorMsg:"",
      isErrorOtherPaperTypeName: false,     
      remarksErrorMsg:"",
      isErrorRemarks: false,
      // エラー情報格納用
      errors: [],
      errorName: [],
      errFlg: false,
      wfileKey:Object,
      isDisabled: true,
    };
  },
  props: {
    isConfirmShow: {
      type: Boolean,
      required: true,
    },
    fileKey:{
      type: Object,
      required: true,
    },
    pRemarks: {
      type: String,
      default: "",
    },
    pFileType: {
      type: String,
      default: "",
    },
    pOtherPaperTypeName: {
      type: String,
      default: "",
    },
    // No4:スキャナ保存対応 書類ID
    paperID: {
      type: String,
      default: "",
    },
  },
  computed: {

  },

  watch: {
    isConfirmShow: function(newVal) {
      if (newVal) {
        this.denchouhou = this.fileKey.folderKey.folderType;
        this.fileName = this.fileKey.fileName;
        this.paperType = this.pFileType;
        if (this.paperType == "7") {
          this.isDisabled = false;
        }
        this.remarks = this.pRemarks;
        this.otherPaperTypeName = this.pOtherPaperTypeName;
        this.$nextTick(function() {
          this.initFocus();
        });
      }
      this.handleBodyScrollOnModalStateChange(newVal)
    },

  },
  methods: {
    onblur(e) {
      Common.onblur(e, this);
    },
    ...mapMutations("businessModule", [
      "processDialogue",
      "handleBodyScrollOnModalStateChange"
    ]),
    // **********************************************
    // * OKボタンをクリック
    // **********************************************
    okBtnCliked() {
      this.reset();
      this.isDisabled = false;
      // 入力チェック
      if (!this.checkInputData()) {
        this.setErrMsg("MTCL1119", [""]);
        this.errFlg = true;
        return;
      }
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.processDialogue(true);
      // パラメータ設定
      let param = {
        // ファイル名
        fileName: this.fileName,
        // No4:スキャナ保存対応 書類ID
        paperID: this.paperID,
        //書類種類
        paperType: Number(this.paperType),
        //その他の書類種別名
        otherPaperTypeName: this.otherPaperTypeName,
        //備考
        remarks: this.remarks,
        //メニューのハンドル(電子取引の場合:0, その他の場合:1)
        denchouhou:this.denchouhou,
        //ファイルキー
        fileKey:this.fileKey,
      };
      // this.$emit("agree");
      // this.reset();
      API_STFMFM02C27_UpdatePropert(param).then(
        (response) => {
        //正常の場合
        if (_.eq(response.result, "0000")) {
          this.processDialogue(false);
          this.$emit("agree");
          this.reset();
        } else {
          this.processDialogue(false);
          // エラー表示
          if (response.errorName != null && response.errorName.length>0) {
              this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [response.errorName[0]])
              )
            );
          } else {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
      }
      );

    },
    
    // **********************************************
    // * キャンセルボタンをクリック
    // **********************************************
    canCelBtnClicked() {
      this.processDialogue(false);
      this.$emit("disagree");
      this.reset();
    },

    // **********************************************
    // * リセット
    // **********************************************
    reset() {
      this.errors.splice(0);
      this.isDisabled = true;
      this.fileNameErrorMsg = "";
      this.isErrorfileName = false;      
      this.otherPaperTypeNameErrorMsg = "";
      this.isErrorOtherPaperTypeName = false;
      this.remarksErrorMsg = "";
      this.isErrorRemarks = false;
    },
    /**
     * 入力値チェック
    */
    checkInputData(){
      var bRet = true;
      // ファイル名チェック
      if (!this.isNullOrEmpty(this.fileName)) {
        // ファイル名に入力禁止文字が使用されている。
        // ※設計書『D - ED005_共通処理設計書.xlsx』参照。  
        if(
          !validation.checkNationalkinsokuchar(this.fileName) ||
          !validation.CheckFileNameInvalid(this.fileName)
        ){
          this.isErrorfileName = true;
          // エラー表示
          this.fileNameErrorMsg = Common.getMessage("MTCL1098", ["名称"]);         
          bRet = false;
        }
        //拡張子が.html、.htmのファイルが含まれる　又はファイルの拡張子が存在しない。
        let file_type = this.fileName.split('.').pop();
        if (file_type == "html" || file_type == "htm" || file_type == "" || file_type == this.fileName){
          this.isErrorfileName = true;
          // エラー表示
          this.fileNameErrorMsg = Common.getMessage("MTCL1107", []);
          bRet = false;
        }
        // 禁止文字列COM1......のチェック
        if(!validation.CheckFileName(this.fileName)){
          this.isErrorfileName = true;
          // エラー表示
          this.fileNameErrorMsg = Common.getMessage("MTFM1190", ["名称"]);         
          bRet = false;
        }
      } else {
        //必須チェック
        this.isErrorfileName = true;
        // エラー表示
        this.fileNameErrorMsg = Common.getMessage("MTCL1001", ["名称"]);
        bRet = false;
      }
     //その他の書類種別チェック
     if(this.paperType == "7"){
        if (!this.otherPaperTypeName) {
          // エラー表示
          this.otherPaperTypeNameErrorMsg = Common.getMessage("MTFM1120", ["その他の書類種別"]);
          this.isErrorOtherPaperTypeName = true;
          bRet = false;
        } else {
          // 入力禁止文字チェックその他の書類種別1-(6)
          if (!validation.checkNationalkinsokuchar(this.otherPaperTypeName) ||
              !validation.CheckFileNameInvalid(this.otherPaperTypeName)) {
            this.isErrorOtherPaperTypeName = true;
            // エラー表示
            this.otherPaperTypeNameErrorMsg = Common.getMessage("MTCL1098", ["その他の書類種別"]);
            bRet = false;
          }
        }
      }
      // 備考入力禁止文字チェック
      if (!this.isNullOrEmpty(this.remarks)) {
          // 入力禁止文字チェックその他の書類種別1-(6)
          if (!validation.checkNationalkinsokuchar(this.remarks) ||
              !validation.CheckFileNameInvalid(this.remarks)) {
            this.isErrorRemarks = true;
            // エラー表示
            this.remarksErrorMsg = Common.getMessage("MTCL1098", ["備考"]);
            bRet = false;
          }
      }
      return bRet;
    },
    
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.fileName.focus();
    },
    // **********************************************
    // * 書類種類設定
    // **********************************************
    handleChangeFileType(e) {
      this.paperType = e.target.value;
      if (this.paperType == "7") {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
      this.otherPaperTypeName = "";
      this.isErrorOtherPaperTypeName = false;
    },
    // **********************************************
    // * 書類種類がその他かを判定
    // **********************************************
    isOtherPaperTypeName(){
      return this.paperType == "7";
    },

    /**
     * null,empty判定
     * @param {判定対象} val 
     */
     isNullOrEmpty(val){
      if(val == null || val == ""){
        return true;
      }
      else{
        return false;
      }
    },
    /**
     * エラー内容セット
     * @param {エラーコード} errCd 
     * @param {エラーコードの埋め込み文字} param 
     */
     setErrMsg(errCd,param){
      if (this.errors.length == 0) {
        this.errors.push(
          Common.createError(
            errCd,
            Common.getMessage(errCd, param)
          )
        );
      }
    },
  },
};
</script>
<style scoped>
.text-input-area {
  margin-left: 10px;
  width: 520px;
  height: 150px;
}
.detail-error{
  margin-left:6em;
  height: 20px;
  border: 0px solid #ACACAC;
  color: red;
}
*+.frm-select{
  margin-left: 0;
}
.flex-row{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.flex-row > .row-label{
  display: inline-block;
  min-width:6em;
}
.flex-row > .row-content{
  /* margin-left: 50px; */
  flex-grow: 1;
}
.row-content .text-input-area{
  margin-left: 0;
}
@media (max-width: 768px) {
  .flex-row{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .flex-row > .row-content{
    width: 100%;
  }
  .row-content .text-input-area{
    width: 100%;
  }
  .row-content .w-180px{
    width: 100%;
    margin-top: 10px;
  }
  .row-content .ml-10px{
    margin-left: 0 !important;
  }
  .detail-error{
    margin-left: 0;
  }
  .frm-btn-row>.frm-item.center{
    flex-wrap: wrap;
    flex-direction: column;
  }
  .frm-btn-row>.frm-item.center .frm-btn:last-child{
    margin-left: 0;
    margin-top: 10px;
  }

}

</style>

